import Box, { Item } from "devextreme-react/box";
import { useContext } from "react";
import { OrderStatus, ROType } from "../../../../types/enums";
import { RetailOrderContext } from "../context/RetailOrderContext";
import CabinetOrderInformationCard from "./CabinetOrderInformationCard";
import CustomerInformationCard from "./CustomerInformationCard";
import PendingOrderCard from "./PendingOrderCard";
import RetailOrderInformationCard from "./RetailOrderInformationCard";
import RetailOrderPaymentInfoCard from "./RetailOrderPaymentInfoCard";
import StoreInformationCard from "./StoreInformationCard";

export default function RetailOrderInformationCards(props: { showPaymentInformationCard?: boolean }) {

	const { order } = useContext(RetailOrderContext);

	return (
		<>
			{
				order.details.orderStatusID === OrderStatus.Pending ?
					<PendingOrderCard />
					:
					props.showPaymentInformationCard ?
						<Box className='order-cards'>
							<Item ratio={1}>
								<RetailOrderInformationCard />
							</Item>
							<Item ratio={1}>
								<CustomerInformationCard />
							</Item>
							<Item ratio={1}>
								<StoreInformationCard />
							</Item>
							{
								order.details.roTypeID !== ROType.Plumbing &&
								<Item ratio={0.6}>
									<RetailOrderPaymentInfoCard />
								</Item>
							}
						</Box>
						:
						<Box className='order-cards'>
							<Item ratio={1}>
								<RetailOrderInformationCard />
							</Item>
							<Item ratio={1}>
								<CustomerInformationCard />
							</Item>
							<Item ratio={1}>
								<StoreInformationCard />
							</Item>
							{
								order.details.cabinetOrder &&
								<Item ratio={1}>
									<CabinetOrderInformationCard />
								</Item>
							}
						</Box>
			}
		</>
	)
}
